module.exports = __webpack_public_path__ + "cae9d217efde1826ef5a604be76fb9fe.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MD.svg
// module id = hT+/
// module chunks = 0